export const getRotationDegrees = (prizeNumber, numberOfPrizes) => {
  const degreesPerPrize = 360 / numberOfPrizes

  // gets us squarely in the middle of a prize
  const initialRotation = degreesPerPrize / 2

  const result = -90 - initialRotation - degreesPerPrize * prizeNumber

  return result
}
export const getStartingRotationDegrees = (prizeNumber, numberOfPrizes) => {
  const degreesPerPrize = 360 / numberOfPrizes

  // gets us squarely in the middle of a prize
  const initialRotation = degreesPerPrize / 2

  const result = (-90 - initialRotation - degreesPerPrize * prizeNumber) + (degreesPerPrize / 2)

  return result
}
export const clamp = (min, max, val) => Math.min(Math.max(min, +val), max)
